(function () {
  'use strict';

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  // convert coreMetrics property to data-aid for Google Analytics
  var cmToGa = function cmToGa(str) {
    var strParts = str.split('-_-');
    var descriptionInKebabCase = strParts[1].match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).map(function (x) {
      return x.toLowerCase();
    }).join('-');
    return strParts[0] + '|@|' + descriptionInKebabCase + '|' + strParts[2];
  };

  var getParentCatID = function getParentCatID(categoryLocale, catID) {
    var _categoryLocale$catID, _categoryLocale$catID2;

    return (_categoryLocale$catID = (_categoryLocale$catID2 = categoryLocale[catID].subcategories.find(function (subcat) {
      return subcat.name === categoryLocale.labels.showAll;
    })) === null || _categoryLocale$catID2 === void 0 ? void 0 : _categoryLocale$catID2.id) !== null && _categoryLocale$catID !== void 0 ? _categoryLocale$catID : catID;
  };

  var deprecatedLocal = {
    verify: function verify(categoryLocale, catID) {
      var catParentID = getParentCatID(categoryLocale, catID);
      var subCatCount = categoryLocale[catID].subcategories.length;
      return categoryLocale[catID].subcategories[0].id !== catParentID || categoryLocale[catID].subcategories[subCatCount - 1].id === catParentID;
    },
    parentCategoryConfig: function parentCategoryConfig(categoryLocale, catID) {
      var catParentID = getParentCatID(categoryLocale, catID);
      var parentConfig = categoryLocale[catParentID];
      parentConfig.subcategories = parentConfig.subcategories.filter(function (subcat) {
        return subcat.name !== categoryLocale.labels.showAll;
      });

      if (catID !== catParentID) {
        parentConfig.subcategories.push({
          name: categoryLocale.labels.showAll,
          id: catParentID
        });
      }

      return parentConfig;
    },
    categoryAdLocale: function categoryAdLocale(categoryLocale) {
      return _.reduce(categoryLocale, function (memo, cat, key) {
        if (cat.banner) {
          // const coreMetrics = cat.banner.coreMetrics ? cat.banner.coreMetrics : cat.banner.coreMetric ?
          var _cat$banner = cat.banner,
              coreMetric = _cat$banner.coreMetric,
              coreMetrics = _cat$banner.coreMetrics;
          var coreMetricsProp = coreMetrics ? coreMetrics : coreMetric;
          var dataAid = coreMetricsProp ? cmToGa(coreMetricsProp) : '';
          memo[key] = {
            banner: _objectSpread2(_objectSpread2({}, cat.banner), {}, {
              'data-aid': dataAid
            })
          };
          return memo;
        }

        return memo;
      }, {});
    }
  };

  /* eslint-plugin-disable angular */

  (function () {
    var catID = wmUtil.getParamByName('c');
    var categoryLocale = window.categoryInfo;
    var parentCategoryConfig;
    var categoryConfig = parentCategoryConfig = categoryLocale[catID];
    var categoryAdLocale = window.categoryAd; // the below code is to handle the old locale js object in category-locale in cultures other than NA
    // this code should be removed once category-locale in all cultures matches category-locale in NA

    if (deprecatedLocal.verify(categoryLocale, catID)) {
      var _categoryAdLocale;

      parentCategoryConfig = deprecatedLocal['parentCategoryConfig'](categoryLocale, catID);
      categoryAdLocale = (_categoryAdLocale = categoryAdLocale) !== null && _categoryAdLocale !== void 0 ? _categoryAdLocale : deprecatedLocal['categoryAdLocale'](categoryLocale);
    } // end of legacy locale code handling
    else {
        console.log('new locale');
      }

    var categoryAdConfig;

    if (categoryAdLocale) {
      categoryAdConfig = categoryAdLocale[catID];
    } // _routes defined and skuCats defined on the page


    angular.module('productPage', ['ngRoute']).config(['$sceDelegateProvider', function ($sceDelegateProvider) {
      $sceDelegateProvider.resourceUrlWhitelist(['self', 'http://cdn*.melaleuca.com/**', 'https://cdn*.melaleuca.com/**']);
    }]) // ---------------------------------------------------------------------- CATEGORY CONTROLLER *
    .controller('categoryController', ['$scope', '$sce', '$location', '$http', '$timeout', 'categoryHelper', 'orderByFilter', '$sceDelegate', '$window', 'dataService', function ($scope, $sce, $location, $http, $timeout, categoryHelper, orderBy, $sceDelegate, $window, dataService) {
      $scope.contentImagesDirectory = $window.contentImagesDirectory;
      $scope.pageSize = $window.isMobileSite ? 36 : 48;
      $scope.size = $window.isMobileSite ? 36 : 48;
      $scope.allProducts = [];
      $scope.products = [];
      $scope.resultCount = 0;
      $scope.loading = false;
      $scope.catID = catID;
      $scope.sortArray = categoryLocale.sortItems;
      $scope.sort = categoryLocale.sortItems[0];
      $scope.labels = categoryLocale.labels;
      $scope.cultureConfig = $window.searchCultureConfig; // Properties for customer price labels

      $scope.customerPriceType = window.customerPriceType.toLowerCase();
      $scope.primaryPriceLabel = $scope.cultureConfig.priceLabels[$scope.customerPriceType];
      $scope.secondaryPriceLabel = $scope.cultureConfig.priceLabels.retail;
      $scope.cmPageId = categoryConfig.cmPageID;
      $scope.pageTitle = parentCategoryConfig.pageTitle;
      $scope.pageBreadcrumbs = categoryConfig.breadCrumbs;
      $scope.adIsContentPage = false;
      $scope.hidePointer = false;
      $scope.alerts = false; // Ad Banner

      if (categoryAdLocale) {
        if (categoryAdConfig !== undefined) {
          if (categoryAdConfig.banner) {
            $scope.categoryBanner = categoryAdConfig.banner;
            $scope.bannerImage = $scope.categoryBanner.img;
            $scope.coreMetrics = $scope.categoryBanner.coreMetrics;

            if (!$scope.categoryBanner.url) {
              $scope.hidePointer = true;
            }
          } else {
            $scope.adIsContentPage = true;
          }
        }
      } // determine if there are any alerts for the current category


      function getAlerts() {
        if (categoryLocale.alerts) {
          return categoryLocale.alerts.filter(function (alert) {
            return alert.categories.indexOf(parseInt(catID)) >= 0;
          });
        } else return [];
      }

      var alerts = getAlerts(); // if alert(s) are found show them

      if (alerts.length > 0) {
        $scope.alerts = alerts;
      }

      $scope.subCategories = parentCategoryConfig.subcategories;

      if ($scope.subCategories.length) {
        $scope.hasCategories = true;
      }

      $scope.filters = categoryConfig.filters || [];
      $scope.signedIn = $window.PageClientData.CustomerStatus; // toggle prices on/off

      $scope.elementTag = function (id) {
        categoryHelper.tracking(id, $scope.cmPageId);
      }; // Survey stuff


      $scope.surveyUrl = '';

      if (categoryLocale[catID].hasOwnProperty('surveyUrl')) {
        $scope.surveyPercent = categoryLocale[catID].surveyPercent || 40;
        $scope.surveyUrl = isMobile ? categoryLocale[catID].surveyUrl.mobile : categoryLocale[catID].surveyUrl.desktop;
      }

      $scope.surveyRandNum = Math.floor(Math.random() * 100 + 1);
      $scope.surveyIsOptOut = $window.localStorage.getItem('categorySurveyOptOut') === 'true';

      $scope.surveyOptOut = function () {
        $scope.surveyIsOptOut = true;
        $window.localStorage.setItem('categorySurveyOptOut', 'true');
      };
      /**
       * Checks inventory control status for list of products,
       * then updates the availability status for those products.
       *
       * @param  {Array} skuList - Array of SKU numbers for all inventory-controlled products
       */


      var checkInventory = function checkInventory(skuList) {
        var stopInterval;
        stopInterval = setInterval(function () {
          if ($window.productInventory) {
            clearInterval(stopInterval);
            dataService.checkInventory(skuList, $scope.allProducts, $scope).then(function () {
              $scope.$apply(function () {
                // Sort by availability, if not sorting by price or points
                if ($scope.sort.field === '') {
                  $scope.allProducts = wmUtil.sortAvailable($scope.allProducts);
                }

                $scope.products = $scope.allProducts.slice(0, $scope.size);
                $scope.loading = false;
              });
            }, function (err) {
              console.info('Failed to sort products by availability');
              $scope.$apply(function () {
                $scope.products = $scope.allProducts.slice(0, $scope.size);
                $scope.loading = false;
              });
            });
          }
        }, 300);
      };

      $scope.addToCart = function (event) {
        // add to cart function
        AnimateAddToDest($get($(event.currentTarget).attr('id')), 'miniCartIcon');
        Melaleuca.Web.AjaxManager.AddProductToCart($(event.currentTarget).data('sku'), $(event.currentTarget).siblings('input').val(), $scope.cmPageId, null, rtnAddToCart);
      };

      $scope.loadMoreResults = function (showAll) {
        showAll = showAll || false;
        $scope.size += $scope.pageSize;

        if (showAll) {
          $scope.size = $scope.resultCount;
        }

        $scope.products = $scope.allProducts.slice(0, $scope.size);
      };

      $scope.sortResults = function () {
        $scope.getResults();
        categoryHelper.tracking('Sorted by ' + $scope.sort, $scope.cmPageId);
      };

      $scope.reduceRefiners = function () {
        return $scope.filters.reduce(function (allChecked, filter) {
          var checked = [];

          if (Array.isArray(filter.refiners)) {
            checked = filter.refiners.filter(function (refiner) {
              return refiner.checked;
            });
            allChecked = allChecked.concat(checked);
          }

          return allChecked;
        }, []);
      };

      $scope.clearFilters = function () {
        $scope.filters.forEach(function (filter, filterIndex) {
          filter.refiners.forEach(function (refiner, refinerIndex) {
            $scope.filters[filterIndex].refiners[refinerIndex].checked = false;
          });
        });
        categoryHelper.tracking('cleared', $scope.cmPageId);
        $scope.getResults();
      };

      var getSelectedFacetsRefiners = function getSelectedFacetsRefiners() {
        return $scope.filters.reduce(function (facetRefinersString, filter) {
          filter.refiners = filter.refiners || [];
          var checkedRefiners = filter.refiners.filter(function (refiner) {
            return refiner.checked;
          }).reduce(function (refiners, refiner) {
            refiners.push(refiner.key);
            return refiners;
          }, []);

          if (checkedRefiners.length) {
            facetRefinersString += "".concat(filter.facetName, ":").concat(checkedRefiners.join(','), ";");
          }

          return facetRefinersString;
        }, '');
      };

      $scope.toggleRefiner = function (facet, refiner) {
        $scope.getResults();
        var isChecked = refiner.checked ? 'checked' : 'unchecked';
        var elementID = "".concat(isChecked, ":").concat(facet.facet, ":").concat(refiner.key);
        categoryHelper.tracking(elementID, $scope.cmPageId, getSelectedFacetsRefiners()); // Store facets by category in session storage

        sessionStorage.setItem('facets' + catID, JSON.stringify($scope.filters));
      };

      $scope.backToTop = function () {
        $('html, body').animate({
          scrollTop: 0
        }, 'fast');
      };

      var buildFilterParams = function buildFilterParams() {
        // click back button or refresh the page
        if (window.performance.navigation.type === 2 || window.performance.navigation.type === 1) {
          // get facets by cateogory from session storage
          $scope.filters = JSON.parse(sessionStorage.getItem('facets' + catID)) || categoryConfig.filters;
        } else {
          sessionStorage.removeItem('facets' + catID);
        }

        return $scope.filters.map(function (filter) {
          var refiners = filter.refiners || [];
          refiners = refiners.filter(function (refiner) {
            return refiner.checked;
          }).map(function (refiner) {
            return refiner.key;
          });
          return {
            facetName: filter.facetName,
            facetId: filter.facetId,
            refiners: refiners
          };
        });
      }; // load the buildFilterParams function when page refreshing


      buildFilterParams();

      var buildParams = function buildParams() {
        return {
          id: 'products_by_category_facets',
          index: wmUtil.searchIndex,
          params: {
            sortField: $scope.sort.field,
            sortDir: $scope.sort.dir,
            from: 0,
            size: 1000,
            categoryId: catID,
            filters: buildFilterParams()
          }
        };
      };

      var updateRefiners = function updateRefiners(aggs) {
        $scope.filters.forEach(function (filter, filterIndex) {
          var thisAggs = aggs[filter.facetId].nested_filter.facet_filter; // Set localized facet name

          if (thisAggs.facet_name.buckets.length) {
            $scope.filters[filterIndex].facetName = thisAggs.facet_name.buckets[0].key;
          }

          var aggRefiners = thisAggs.refiners.buckets;
          $scope.filters[filterIndex].refiners = $scope.filters[filterIndex].refiners || [];
          filter.refiners = filter.refiners.map(function (aggRefiner) {
            aggRefiner.count = 0;
            return aggRefiner;
          });
          aggRefiners.forEach(function (aggRefiner) {
            var refinerIndex = $scope.filters[filterIndex].refiners.findIndex(function (scopeRef) {
              return scopeRef.key === aggRefiner.key;
            });

            if (refinerIndex > -1) {
              // If exists, update individual properties (avoid wiping out 'checked' status)
              $scope.filters[filterIndex].refiners[refinerIndex].key = aggRefiner.key;
              $scope.filters[filterIndex].refiners[refinerIndex].count = aggRefiner.doc_count;
              $scope.filters[filterIndex].refiners[refinerIndex].sort = aggRefiner.refiner_sort.value;
            } else {
              $scope.filters[filterIndex].refiners.push({
                key: aggRefiner.key,
                count: aggRefiner.doc_count,
                sort: aggRefiner.refiner_sort.value
              });
            }
          });
        });
      };

      $scope.getResults = function () {
        $scope.loading = true; // Store facets by category in session storage

        sessionStorage.setItem('facets' + catID, JSON.stringify($scope.filters));
        dataService.getSearchResults(buildParams()).then(function successCallback(response) {
          $timeout(function () {
            $scope.allProducts = response.data.hits.hits.map(function (product) {
              return wmUtil.mapProductFields(product._source);
            });
            updateRefiners(response.data.aggregations); // Sort by availability for off-sale products

            if ($scope.sort.field === '') {
              $scope.allProducts = wmUtil.sortAvailable($scope.allProducts);
            }

            $scope.resultCount = response.data.hits.total; // Create list of inventory controlled SKUs

            var skuList = $scope.allProducts.filter(function (product) {
              return product.is_inventory_controlled;
            }).map(function (product) {
              return product.sku;
            }); // Check inventory status, then update data

            if (skuList.length) {
              checkInventory(skuList);
            } else {
              $scope.products = $scope.allProducts.slice(0, $scope.size);
              $scope.loading = false;
            }
          });
        });
      }; // Get results on page load


      $scope.getResults(); //Inject Ad Banner if the Ad comes from a content page and enable JS linked to those pages

      if (categoryAdLocale) {
        if ($scope.adIsContentPage) {
          setTimeout(function () {
            InsertContentPage(categoryAdConfig.contentPage.contentPageName, 'adIsContentPage', function () {
              var $adContainer = $('#adIsContentPage');
              var $scripts = $adContainer.find('script');

              if ($scripts) {
                $scripts.each(function (index, value) {
                  var externalScript = $(value).attr('src');

                  if (externalScript) {
                    $.getScript(externalScript);
                  } else {
                    var script = $(value).html();
                    eval(script);
                  }
                });
              }
            });
          }, 0);
        }
      } // $scope.insertContentPageAd = function() {
      //   console.log('content loaded')
      //   $window.$sce.InsertContentPage(categoryAdConfig.contentPage.contentPageName, 'adIsContentPage');
      // };


      $scope.$on('$viewContentLoaded', function () {
        console.log('View Content Loaded');
      }); // ----------------------------
      //
      // Mobile-specific Functions
      //
      // ----------------------------

      $scope.filterClass = 'filter-closed';

      $scope.toggleFilterNav = function () {
        if ($scope.filterClass === 'filter-closed') {
          $scope.filterClass = 'filter-open';
          $('.mobile-wrapper').addClass('is-fixed');
        } else {
          $scope.filterClass = 'filter-closed';
          $timeout(function () {
            $('.mobile-wrapper').removeClass('is-fixed');
          }, 500);
        }
      };
    }]) // changes the facet--is-open class on the refiners list
    .directive('toggleFacet', ['categoryHelper', function (categoryHelper) {
      return {
        restrict: 'A',
        link: function link(scope, element) {
          element.bind('click', function () {
            element.parent().toggleClass('facet--is-closed');
            element.next().slideToggle(250);
          });
        }
      };
    }]) // FACTORIES //
    .factory('categoryHelper', ['$sce', function ($sce) {
      var factory = {};

      factory.tracking = function (elementId, cmPageId) {
        var allFacetsRefiners = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        allFacetsRefiners = allFacetsRefiners.length ? "-_--_--_-".concat(allFacetsRefiners) : '';
        cmCreateElementTag(elementId, cmPageId, "".concat(standardElementAnalyticsAttributes).concat(allFacetsRefiners));
      };

      return factory;
    }]);
    angular.bootstrap(document.getElementById('category-page'), ['productPage', 'ngWmUtil']);
  })();

}());
